module.exports = __webpack_public_path__ + "static/cosi4s-ac459e1be36abae1ad62511446b1f34d.jpg";